module.exports = __webpack_public_path__ + "static/media/darru.8db74078.jpg";